export const BLOG_INLINE_IMAGE_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    image_url: "",
    mobile_image_url: "",
    alt_text: "",
    caption: "",
    caption_text_color: "#737373",
    caption_alignment: "left",
    border_radius_px: 8,
    status: false,
  },

  BLOG_INLINE_IMAGE_FIELDS_CONFIG: [
    {
      fieldName: "image_url",
      label: "Desktop image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image (tablet and desktop)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image_url",
      label: "Mobile image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — separate image for small screens",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_text",
      label: "Alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image for accessibility",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "caption",
      label: "Caption",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Optional caption below the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "caption_text_color",
      label: "Caption colour",
      value: "#737373",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#737373",
      required: false,
      defaultValue: "#737373",
    },
    {
      fieldName: "caption_alignment",
      label: "Caption alignment",
      value: "left",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Alignment",
      required: false,
      defaultValue: "left",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" },
      ],
    },
    {
      fieldName: "border_radius_px",
      label: "Corner radius (px)",
      value: 8,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "8",
      required: false,
      defaultValue: 8,
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [],
};
